import { connect } from "react-redux";

var RosterSelectors = require("lib/selectors/RosterSelectors");
var CurrentUser = require("lib/account/CurrentUser");

var WidgetContainer = require("components/data/widgets/WidgetContainer.js")
var WidgetConfig = require('lib/widgets/WidgetsConfig')
var StudentAvatar = require("components/avatars/StudentAvatar");

@connect(
  (state, props) => ({
    student: RosterSelectors.student({ state, id: props.studentID })
  }),
  (dispatch, props) => ({
    // Currently undefined, but we can do this for sure
    // populateData: () => dispatch(RosterActions.batchFetchStudent(props.studentID))
  })
)
class DataStudentDigest extends React.Component {
  constructor(props) {
    super();
    autobind(this);
  }


  render() {
    var {student} = this.props
    var currentUser = CurrentUser.get()
    var widgetParams = { topLevelDigest: WidgetConfig.STUDENT_ENTITY_TYPE, period: WidgetConfig.PERIOD, adminID: [currentUser.id] }
    var widgetContainer = <WidgetContainer userID={this.props.studentID} widgetParams={widgetParams} />

    return (
      <div className="dataStudentDigest">
        <div className="showOnPrint">
          <h1 style={{ textAlign: 'center' }}>{student.display_name}</h1>
        </div>
        {widgetContainer}
      </div>
    );
  }
}

DataStudentDigest.WrappedComponent.propTypes = StrictPropTypes({
  studentID: PropTypes.number,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  showFullData: PropTypes.bool,
  student: PropTypes.object,

});

module.exports = DataStudentDigest


// WEBPACK FOOTER //
// ./modules/components/users/students/DataStudentDigest.js